import { Link } from "react-router-dom";
import { useVideo } from "../../../hooks/useVideo";
import LoadingSpinner from "../../loader/Loader";
import parse from "html-react-parser";
import { useGetAboutQuery } from "../../../features/api/aboutApiSlice";

const AdminAboutList = () => {
  const { formatDate } = useVideo();
  const {
    data: about,
    isLoading,
    isError,
  } = useGetAboutQuery(undefined, {
    pollingInterval: 15000,
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true,
  });

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <p>Error loading about.</p>;

  return (
    <div className="transactions-container">
      <div className="dashboard-top-section">
        <div className="dash-top-flex">
          <h1 className="dashboard-title">About</h1>
        </div>
      </div>

      <table className="transactions-table">
        <thead>
          <tr>
            <th>description</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {about?.map((tx) => (
            <tr key={tx?._id}>
              <td>{parse(`${tx?.description}`)}</td>
              <td>{formatDate(tx?.createdAt)}</td>
              <td className="actions-container">
                <Link
                  className="ed-button"
                  aria-label={`edit ${tx?.description}`}
                  to={`/admin/about/editabout/${tx?._id}`}
                >
                  Edit
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminAboutList;
